import React, { useEffect, useState } from "react";
import AppStore from "../../../config/AppStore";
import {
  sendRequestGetPrepingDetailsReportsAdmin,
} from "../../../view_logics/Reports/Reports";
import ModalComponent from "../../../components/common/Modal";
import _ from "lodash";
import Spinner from "../../../components/common/Spinner";
import Pagination from "../../../components/common/Pagination";
import { format } from "date-fns";

const PrepingReportDetails = ({ prepingId, filters,isVisible }) => {
  //if (!prepingId) return;
  const [reportsFilterLoading, setReportsFilterLoading] = useState(false);

  let store = AppStore.getAppStoreInstance();
  const [apiData, setApiData] = useState([]);
  const [reportsList, setReportsList] = useState([]);
  const [displayItems, setDisplayItems] = useState([]);
  const [prepingDetailsData, setPrepingDetailsData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(() => {
    if (isVisible) {
      setPageNo(1); // reset to page 1 when modal is opened
    }
  }, [isVisible, prepingId]);

  const formatDate = (date) => format(date, "yyyy-MM-dd");

  useEffect(() => {
    if (!prepingId) return;
    const fetchPrepingData = async () => {
      setReportsFilterLoading(true);
      try {
        const inputObj = {
          accessToken: store.getState().login.accessToken,
          url: "reports",
          data: {
            "email":filters.email,
            "from": formatDate(filters.from),
            "to": formatDate(filters.to),
            // "advertiserId":filters.advertiserId,
            "offerId": prepingId,
            'pageNo': pageNo
          },
          loadingHandler: setReportsFilterLoading,
          dataHander: setPrepingDetailsData,
        };

        const response = await sendRequestGetPrepingDetailsReportsAdmin(inputObj);
        setReportsFilterLoading(false);
        if (response) {
          setReportsList(response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPrepingData();
  }, [prepingId, filters, pageNo]);

  useEffect(() => {
    const totalPages = prepingDetailsData.totalPages;
    setTotalPage(totalPages); // if you're storing it in state
  }, [prepingDetailsData]);


  return (
    <>
      <ModalComponent
        id={"preping_details_report_model"}
        size={"modal-lg"}
        //saveHandler={}
        modalHeading={"Preping Details Report"}
      >
        <div Style='overflow: scroll;' >
          <table id="reports" className="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Email</th>
                <th scope="col">Date</th>
                <th scope="col">Ping Url</th>
                <th scope="col">Ping Posting Data</th>
                <th scope="col">Ping Header Posting Data</th>
                <th scope="col">Ping Response</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {prepingDetailsData.rows?.length > 0 ? (
                prepingDetailsData.rows.slice(0, 10)?.map((reportDetails, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr className="table-info">
                        <td>{reportDetails.id}</td>
                        <td>{reportDetails.email} </td>
                        <td>{reportDetails.date}</td>
                        <td>{reportDetails.request}</td>
                        <td>{reportDetails.ping_posting_data ? JSON.stringify(reportDetails.ping_posting_data, null, 2) : ""}</td>
                        <td>{reportDetails.ping_posting_header_data ? JSON.stringify(reportDetails.ping_posting_header_data, null, 2) : ''}</td>
                        <td>{reportDetails.response ? JSON.stringify(reportDetails.response, null, 2) : ''}</td>
                        <td>{reportDetails.status?'SUCCESS':'FAILED'}</td>
                      </tr>
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12">No records found …</td>
                </tr>
              )}
            </tbody>
            {reportsFilterLoading && <Spinner />}
          </table>
        </div>

        <Pagination pageNo={pageNo} totalPage={totalPage} setPageNo={setPageNo} />

      </ModalComponent>
    </>
  );
};
export default PrepingReportDetails;
